import { render, staticRenderFns } from "./AuthorizationPage.vue?vue&type=template&id=09789ade&scoped=true"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationPage.vue?vue&type=style&index=0&id=09789ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09789ade",
  null
  
)

export default component.exports